import { useTranslation } from "../../../../hooks/useTranslation";
import { DimensionInformation, ProductDetail } from "../types";
import {
  Grid2,
  CardMedia,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Chip,
} from "@mui/material";
import { Link } from "react-router-dom";
import { SideBar } from "./SideBar";
import { Copyable } from "../../../../components/copyable/Copyable";

type DetailProps = {
  productDetail?: ProductDetail;
};

export const Detail = ({ productDetail }: DetailProps) => {
  const { translate, translateWithoutPrefix } = useTranslation("pages.product");

  const getDimensionText = (dimension: DimensionInformation | undefined) => {
    if (!dimension?.value) return translateWithoutPrefix("common.unknown");
    return dimension.value + " " + dimension.unit;
  };

  const getWHLText = () => {
    if (
      !productDetail?.marketplaceProduct?.product?.width ||
      !productDetail?.marketplaceProduct?.product?.height ||
      !productDetail?.marketplaceProduct?.product?.length
    )
      return translateWithoutPrefix("common.unknown");

    return (
      getDimensionText(productDetail?.marketplaceProduct?.product?.width) +
      " - " +
      getDimensionText(productDetail?.marketplaceProduct?.product?.height) +
      " - " +
      getDimensionText(productDetail?.marketplaceProduct?.product?.length)
    );
  };

  return (
    <Grid2 container>
      <Grid2 size={{ xs: 12, lg: 9 }}>
        <Grid2 container>
          <Grid2
            size={{
              md: 2,
            }}
          >
            <CardMedia
              component="img"
              src={productDetail?.productImageUrl}
              alt={productDetail?.marketplaceProduct?.itemName}
              title={productDetail?.marketplaceProduct?.itemName}
              width="100%"
              sx={{
                maxWidth: "300px",
                maxHeight: "300px",
                objectFit: "contain",
              }}
            />
          </Grid2>
          <Grid2>
            <CardContent
              sx={{
                maxWidth: "800px",
              }}
            >
              <Typography
                component={Link}
                to={`https://www.amazon.com/dp/${productDetail?.asin}`}
                target="_blank"
                rel="noopener noreferrer"
                variant="h6"
                sx={{ cursor: "pointer", textDecoration: "none" }}
              >
                {productDetail?.marketplaceProduct?.itemName ??
                  translateWithoutPrefix("common.unknown")}
              </Typography>

              <Table size="small">
                <TableBody>
                  <TableRow>
                    <TableCell>{translate("asin")}</TableCell>
                    <TableCell>
                      <Copyable
                        initialLabel={
                          productDetail?.asin?.toUpperCase() ??
                          translateWithoutPrefix("common.unknown")
                        }
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{translate("sku")}</TableCell>
                    <TableCell>
                      <Copyable
                        initialLabel={
                          productDetail?.sku?.toUpperCase() ??
                          translateWithoutPrefix("common.unknown")
                        }
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{translate("productStatus")}</TableCell>
                    <TableCell>
                      <Chip
                        variant="filled"
                        color="success"
                        size="small"
                        label={translate(
                          "status." +
                            (productDetail?.storeProductStatus ?? "NO_DATA"),
                        )}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{translate("dimensions")}</TableCell>
                    <TableCell>{getWHLText()}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{translate("weight")}</TableCell>
                    <TableCell>
                      {getDimensionText(
                        productDetail?.marketplaceProduct?.product?.weight,
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{translate("desi")}</TableCell>
                    <TableCell>
                      {productDetail?.marketplaceProduct?.product?.desi}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </CardContent>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 size={{ xs: 12, lg: 3 }}>
        <SideBar productDetail={productDetail} />
      </Grid2>
    </Grid2>
  );
};
